import { getFormateDate, safeJsonParse } from "./stringUtility";

export const getLocalStorageData = (key) => safeJsonParse(localStorage.getItem(key));

export const getCompanyId = () => {
  const companyLocalData = getLocalStorageData("company_data");
  return companyLocalData?.company_id;
};

export const getCompanyData = () => {
  const companyLocalData = getLocalStorageData("company_data");
  return companyLocalData;
};

export const getUserToken = () => {
  const userLocalData = getLocalStorageData("myUserData");
  return userLocalData?.token;
};

export const getRefreshToken = () => {
  const userLocalData = getLocalStorageData("myUserData");
  return userLocalData?.refresh_token;
};

export const getUserData = () => {
  const userLocalData = getLocalStorageData("myUserData");
  return userLocalData;
};

// export const getUserName = () => {
//   const userLocalData = getLocalStorageData("myUserData");
//   return userLocalData?.name;
// };

export const returnWholeData = () => {
  const userLocalData = getLocalStorageData("myUserData");
  return userLocalData;
};

export const getOrganizationId = () => {
  const userLocalData = getLocalStorageData("myUserData");
  return userLocalData?.org_id;
};

export const getOrganizationName = () => {
  const userLocalData = getLocalStorageData("myUserData");
  return userLocalData?.organization_name;
};

export const getOrganizations = () => {
  const userLocalData = getLocalStorageData("myUserData");
  return userLocalData?.workspaces;
};

export const getUserId = () => {
  const userLocalData = getLocalStorageData("myUserData");
  return userLocalData?.user_id;
};

export const getIsOwner = () => {
  const userLocalData = getLocalStorageData("ownerInfo");
  return userLocalData?.isOwner;
};

export const getDateFormat = () => {
  const userLocalData = getLocalStorageData("date_formate");
  return userLocalData?.dateFormate;
};

export const getDateTimeFormat = () => {
  const userLocalData = getLocalStorageData("company_preference") || {};
  return {
    dateFormate: userLocalData.date_format,
    timeFormate: userLocalData.time_format,
  };
};

export const isKeepLoggedIn = () => {
  const userInfo = getLocalStorageData("userInfo");
  return userInfo?.keepLoggedIn;
};

export const getSavedView = () => {
  const savedView = getLocalStorageData("saved_view");
  return savedView;
};

export const setMySpaceColumnOrder = (id, data) => {
  try {
    const columnOrder = getLocalStorageData("my_space_column_orders");
    let updatedColumnOrder = {};
    if (columnOrder) {
      updatedColumnOrder = {
        ...columnOrder,
        [id]: data,
      };
      localStorage.setItem("my_space_column_orders", JSON.stringify(updatedColumnOrder));
      return true;
    } else {
      localStorage.setItem("my_space_column_orders", JSON.stringify({ [id]: data }));
      return true;
    }
  } catch (error) {
    return false;
  }
};

export const getUserThemeColor = () => {
  const userPreferences = safeJsonParse(localStorage.getItem("userPreferences"));
  return userPreferences?.theme_color || "#004EFF";
};

export const setMySpaceVisibleFields = (id, data) => {
  try {
    const visibleFields = getLocalStorageData("my_space_visible_fields");
    let updatedVisibleFields = {};
    if (visibleFields) {
      updatedVisibleFields = {
        ...visibleFields,
        [id]: data,
      };
      localStorage.setItem("my_space_visible_fields", JSON.stringify(updatedVisibleFields));
      return true;
    } else {
      localStorage.setItem("my_space_visible_fields", JSON.stringify({ [id]: data }));
      return true;
    }
  } catch (error) {
    return false;
  }
};

export const getMySpaceColumnOrder = (id) => {
  const columnOrder = getLocalStorageData("my_space_column_orders");
  if (columnOrder && columnOrder[id]) {
    return columnOrder[id];
  }
  return null;
};

export const getMySpaceVisibleFields = (id) => {
  const visibleFields = getLocalStorageData("my_space_visible_fields");
  if (visibleFields && visibleFields[id]) {
    return visibleFields[id];
  }
  return null;
};

export const checkAccessPermission = (permission) => {
  const companyAccessData = getLocalStorageData("myUserCompanyAccessData");
  const companyPermission = companyAccessData?.permissions?.find((perm) => perm.sub_module === permission);
  return companyPermission?.permission === 1;
};
